// @ts-nocheck
// Updated: Fixed API endpoints and integrated CoinProfileModal
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ThemeProvider } from './contexts/ThemeContext';
import { LastUpdateProvider } from './contexts/LastUpdateContext';
import { AnalysisProvider } from './contexts/AnalysisContext';
import FloatingProgressIndicator from './components/FloatingProgressIndicator';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import AdminDashboard from './pages/AdminDashboard';
import Overview from './pages/Overview';
import Explore from './pages/Explore';
import SearchCoin from './pages/SearchCoin';
import AgentAnalysis from './pages/AgentAnalysisRedesign';
import StrategyAdvisor from './pages/StrategyAdvisor';
import Contest from './pages/Contest';
import ContestSubmit from './pages/ContestSubmit';
import ContestLeaderboard from './pages/ContestLeaderboard';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ComingSoon from './pages/ComingSoon';
import WhiteLabelPresentation from './pages/WhiteLabelPresentation';
import PairsAnalysis from './pages/PairsAnalysis';

// Google Analytics page tracking component
function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever route changes
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-TT45LLQERF', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

// Scroll to top on route change
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <LastUpdateProvider>
          <AnalysisProvider>
            <Router>
            <GoogleAnalyticsTracker />
            <ScrollToTop />
            <FloatingProgressIndicator />
            <div className="App">
              <Routes>
              {/* Public landing page */}
              <Route path="/" element={<Home />} />

              {/* Protected routes */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/overview"
                element={
                  <ProtectedRoute>
                    <Overview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/explore"
                element={
                  <ProtectedRoute>
                    <Explore />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/search"
                element={
                  <ProtectedRoute>
                    <SearchCoin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/agent-analysis"
                element={
                  <ProtectedRoute>
                    <AgentAnalysis />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/strategy-advisor"
                element={
                  <ProtectedRoute>
                    <StrategyAdvisor />
                  </ProtectedRoute>
                }
              />

              {/* Contest Pages */}
              <Route path="/contest" element={<Contest />} />
              <Route
                path="/contest/submit"
                element={
                  <ProtectedRoute>
                    <ContestSubmit />
                  </ProtectedRoute>
                }
              />
              <Route path="/contest/leaderboard" element={<ContestLeaderboard />} />

              {/* Public footer pages */}
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />

              {/* Private White Label Presentation - NOT publicly listed */}
              <Route path="/wl-partner-deck" element={<WhiteLabelPresentation />} />

              {/* Pairs Analysis - requires authentication */}
              <Route
                path="/pairs-analysis"
                element={
                  <ProtectedRoute>
                    <PairsAnalysis />
                  </ProtectedRoute>
                }
              />

              {/* Coming Soon pages */}
              <Route
                path="/pricing"
                element={<ComingSoon title="Pricing" description="We're designing flexible pricing plans to suit traders of all levels. Stay tuned!" />}
              />
              <Route
                path="/docs"
                element={<ComingSoon title="Documentation" description="Comprehensive guides and API documentation coming soon to help you get the most out of InvestVerse.AI." />}
              />
              <Route
                path="/api"
                element={<ComingSoon title="API Access" description="Programmatic access to our AI-powered analysis is on the way. Build your own trading tools with our API." />}
              />
              <Route
                path="/blog"
                element={<ComingSoon title="Blog" description="Insights, tutorials, and market analysis articles are coming soon. Follow us to stay updated!" />}
              />
              <Route
                path="/changelog"
                element={<ComingSoon title="Changelog" description="Track our latest features, improvements, and updates. Coming soon!" />}
              />

              {/* Redirect /login to homepage with login modal */}
              <Route
                path="/login"
                element={<Navigate to="/?showLogin=true&mode=login" replace />}
              />
              <Route
                path="/register"
                element={<Navigate to="/?showLogin=true&mode=register" replace />}
              />
              </Routes>
            </div>
          </Router>
          </AnalysisProvider>
        </LastUpdateProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;